<template>
  <div>
    <span v-for="err in filteredErrors" :key="err.code">
      <span
        v-if="$i18n.i18next.exists('validation_errors.' + err.code)"
        class="err"
        :id="'validation_error_' + err.code"
      >
        {{ $t('validation_errors.' + err.code) }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'FormValidationError',
  props: ['validationErrors', 'jsonPath'],
  data: function () {
    return {
      filteredErrors: this.filterErrors()
    };
  },
  watch: {
    validationErrors: function () {
      this.filteredErrors = this.filterErrors();
    }
  },
  methods: {
    filterErrors: function () {
      return this.validationErrors.filter(err => err.path === this.jsonPath);
    }
  }
};
</script>

<style>
.err {
  color: red;
  margin-left: 0.5em;
}
</style>
